import Vue from "vue";
import Router from "vue-router";
import { allRoutes } from "./routes/allRoutes";

Vue.use(Router);

export default function (lang) {
  return new Router({
    mode: "history",
    routes: allRoutes[lang],

    scrollBehavior: function (to) {
      if (to.hash) {
        return { selector: to.hash };
      } else {
        if (to.name === "services-page") {
        } else return { x: 0, y: 0 };
      }
    },
  });
}



// WEBPACK FOOTER //
// ./src/router/index.js